import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_PROGRAM_CONFIGS, GET_PROGRAM_CONFIGS_ERROR, GET_PROGRAM_CONFIGS_SUCCESS } from '../../actions.js';

function* getGetProgramConfigs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/project-config`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      // params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_CONFIGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_CONFIGS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_CONFIGS_ERROR, payload: error });
  }
}

export function* watchGetProgramConfigs() {
  yield takeEvery(GET_PROGRAM_CONFIGS, getGetProgramConfigs);
}

function* getProgramConfigsSaga() {
  yield all([fork(watchGetProgramConfigs)]);
}

export default getProgramConfigsSaga;
